/**
 * Application entry point.
 *
 * Every module is initialised unconditionally and each one bails out early if
 * the elements it owns are not on the page. That keeps this file a flat,
 * readable manifest instead of a tree of page-type conditionals.
 */

import '../css/app.css'

import { initTheme } from './modules/theme'
import { initDrawers } from './modules/drawer'
import { initCart } from './modules/cart'
import { initWishlist } from './modules/wishlist'
import { initReveal } from './modules/reveal'
import { initGallery } from './modules/gallery'
import { initSearch } from './modules/search'
import {
  initAutoSubmit,
  initBillingToggle,
  initCountdowns,
  initFormGuards,
  initHeader,
} from './modules/ui'

function boot(): void {
  initTheme()
  initHeader()
  initDrawers()
  initCart()
  initWishlist()
  initSearch()
  initGallery()
  initReveal()
  initCountdowns()
  initAutoSubmit()
  initFormGuards()
  initBillingToggle()

  // Signals to CSS that JS is running — used to hide no-JS fallbacks.
  document.documentElement.classList.add('js-ready')
}

// The bundle is loaded with `defer`, so the DOM is already parsed by the time
// this runs; the readyState check is a guard for any future non-deferred use.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true })
} else {
  boot()
}
